module.exports = __webpack_public_path__ + "media/components/signup/static/eye-4129860383547ee4650be338126f7ffa.svg";